<script>
import appConfig from "@/app.config";
import ApplicationDataFieldsTable from "@/components/application-data-fields/crud/Table";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "لیست فیلدهای اطلاعات",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    ApplicationDataFieldsTable,
  },
  computed: {
    id() {
      return parseInt(this.$route.params.applicationId);
    },
  },
  data() {
    return {
      title: "لیست فیلدهای اطلاعات",
      items: [
        {
          text: "مدیریت فیلدهای اطلاعات",
          active: true,
        },
        {
          text: "لیست فیلدهای اطلاعات",
          to: { name: "application-data" },
        },
      ],
      application: null,
      tableDetail: JSON.parse(
        JSON.stringify(this.$store.state.tables.application_data)
      ),
    };
  },
  mounted() {
    if (typeof this.tableDetail.application.id === "undefined") {
      this.fetchApplication();
    } else {
      if (this.tableDetail.application.id !== this.id) {
        this.fetchApplication();
      }
    }
  },
  methods: {
    fetchApplication() {
      this.$axios
        .get(`applications/${this.$route.params.applicationId}`)
        .then((res) => {
          this.application = res.data;
          this.title = ' لیست فیلدهای اپلیکیشن "' + this.application.name + '"';
          this.items[0].text =
            ' لیست فیلدهای اپلیکیشن "' + this.application.name + '"';
          this.tableDetail.application = this.application;
        });
    },
  },
};
</script>

<template>
  <Layout :key="id">
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <ApplicationDataFieldsTable :application-id="id" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
